(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["stadat/catalog.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("layout.html", true, "stadat/catalog.html", false, function(t_3,t_2) {
if(t_3) { cb(t_3); return; }
parentTemplate = t_2
for(var t_1 in parentTemplate.blocks) {
context.addBlock(t_1, parentTemplate.blocks[t_1]);
}
output += "\r\n\r\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("content"))(env, context, frame, runtime, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
output += t_4;
output += "\r\n\r\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("sidebar"))(env, context, frame, runtime, function(t_7,t_6) {
if(t_7) { cb(t_7); return; }
output += t_6;
output += "\r\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_content(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var frame = frame.push(true);
output += "\r\n<div id=\"catalog\" class=\"view-panel-catalog\">\r\n    ";
if(runtime.contextOrFrameLookup(context, frame, "catalog_title") != null) {
output += "\r\n        <div id=\"catalog-title\" class=\"title-block\"";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "get")),"topic")) {
output += " style=\"background-color: ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "topic_colors")),runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "topics")),"urlRevMap")),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "get")),"topic"))), env.opts.autoescape);
output += "\"";
;
}
output += ">\r\n            <h1>";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "catalog_title"), env.opts.autoescape);
output += "</h1>\r\n            <span class=\"item-count\">(";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "items")),"length"), env.opts.autoescape);
output += ")</span>\r\n        </div>\r\n\r\n        <div id=\"catalog-tools\">\r\n            <div class=\"tools-row\">\r\n                <div class=\"tools-left\">\r\n                    ";
if(runtime.contextOrFrameLookup(context, frame, "categories") != null) {
output += "\r\n                        <label id=\"categories-label\" for=\"categories-select\"";
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "get")),"kategoria")) {
output += " selected";
;
}
output += ">";
output += runtime.suppressValue(env.getFilter("trans").call(context, "catalog.category"), env.opts.autoescape);
output += "</label>\r\n                        <select id=\"categories-select\">\r\n                            <option value=\"\">";
output += runtime.suppressValue(env.getFilter("trans").call(context, "catalog.all_category"), env.opts.autoescape);
output += "</option>\r\n                            ";
frame = frame.push();
var t_10 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "categories")),"abc");
if(t_10) {t_10 = runtime.fromIterator(t_10);
var t_9 = t_10.length;
for(var t_8=0; t_8 < t_10.length; t_8++) {
var t_11 = t_10[t_8];
frame.set("cat_name", t_11);
frame.set("loop.index", t_8 + 1);
frame.set("loop.index0", t_8);
frame.set("loop.revindex", t_9 - t_8);
frame.set("loop.revindex0", t_9 - t_8 - 1);
frame.set("loop.first", t_8 === 0);
frame.set("loop.last", t_8 === t_9 - 1);
frame.set("loop.length", t_9);
output += "\r\n                                <option value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "categories")),"urlMap")),t_11), env.opts.autoescape);
output += "\"";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "get")),"kategoria") == runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "categories")),"urlMap")),t_11)) {
output += " selected";
;
}
output += ">";
output += runtime.suppressValue(t_11, env.opts.autoescape);
output += "</option>\r\n                            ";
;
}
}
frame = frame.pop();
output += "\r\n                        </select>\r\n                    ";
;
}
output += "\r\n                </div>\r\n                <div class=\"tools-right\">\r\n                    ";
var t_12;
t_12 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "get")),"rendezes") + "/" + runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "get")),"sorrend");
frame.set("sort_val", t_12, true);
if(frame.topLevel) {
context.setVariable("sort_val", t_12);
}
if(frame.topLevel) {
context.addExport("sort_val", t_12);
}
output += "\r\n                    <label id=\"sort-label\" for=\"sort-select\">";
output += runtime.suppressValue(env.getFilter("trans").call(context, "catalog.sort_by"), env.opts.autoescape);
output += "</label>\r\n                    <select id=\"sort-select\">\r\n                        <option value=\"tablaszam/novekvo\"";
if(runtime.contextOrFrameLookup(context, frame, "sort_val") == "tablaszam/novekvo") {
output += " selected";
;
}
output += ">";
output += runtime.suppressValue(env.getFilter("trans").call(context, "catalog.sort_by_tableno_asc"), env.opts.autoescape);
output += "</option>\r\n                        <option value=\"tablaszam/csokkeno\"";
if(runtime.contextOrFrameLookup(context, frame, "sort_val") == "tablaszam/csokkeno") {
output += " selected";
;
}
output += ">";
output += runtime.suppressValue(env.getFilter("trans").call(context, "catalog.sort_by_tableno_desc"), env.opts.autoescape);
output += "</option>\r\n                        <option value=\"cim/novekvo\"";
if(runtime.contextOrFrameLookup(context, frame, "sort_val") == "cim/novekvo") {
output += " selected";
;
}
output += ">";
output += runtime.suppressValue(env.getFilter("trans").call(context, "catalog.sort_by_name_asc"), env.opts.autoescape);
output += "</option>\r\n                        <option value=\"cim/csokkeno\"";
if(runtime.contextOrFrameLookup(context, frame, "sort_val") == "cim/csokkeno") {
output += " selected";
;
}
output += ">";
output += runtime.suppressValue(env.getFilter("trans").call(context, "catalog.sort_by_name_desc"), env.opts.autoescape);
output += "</option>\r\n                        <option value=\"datum/novekvo\"";
if(runtime.contextOrFrameLookup(context, frame, "sort_val") == "datum/novekvo") {
output += " selected";
;
}
output += ">";
output += runtime.suppressValue(env.getFilter("trans").call(context, "catalog.sort_by_nextupdate_asc"), env.opts.autoescape);
output += "</option>\r\n                        <option value=\"datum/csokkeno\"";
if(runtime.contextOrFrameLookup(context, frame, "sort_val") == "datum/csokkeno") {
output += " selected";
;
}
output += ">";
output += runtime.suppressValue(env.getFilter("trans").call(context, "catalog.sort_by_nextupdate_desc"), env.opts.autoescape);
output += "</option>\r\n                    </select>\r\n                </div>\r\n            </div>\r\n            <div class=\"tools-row\">\r\n                <div class=\"tools-left\">\r\n                    ";
var tasks = [];
tasks.push(
function(callback) {
env.getTemplate("widgets/3color_h.html", false, "stadat/catalog.html", false, function(t_14,t_13) {
if(t_14) { cb(t_14); return; }
callback(null,t_13);});
});
tasks.push(
function(template, callback){
template.render(context.getVariables(), frame, function(t_16,t_15) {
if(t_16) { cb(t_16); return; }
callback(null,t_15);});
});
tasks.push(
function(result, callback){
output += result;
callback(null);
});
env.waterfall(tasks, function(){
output += "\r\n                </div>\r\n                <div class=\"tools-right\">\r\n                    <button id=\"btn-open-all\" type=\"button\">";
output += runtime.suppressValue(env.getFilter("trans").call(context, "catalog.action_open_all"), env.opts.autoescape);
output += "</button>\r\n                    <button id=\"btn-close-all\" type=\"button\">";
output += runtime.suppressValue(env.getFilter("trans").call(context, "catalog.action_close_all"), env.opts.autoescape);
output += "</button>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <div id=\"catalog-list\">\r\n            <ul>\r\n                ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "items")),"length") == 0) {
output += "<li class=\"noresult\">";
output += runtime.suppressValue(env.getFilter("trans").call(context, "catalog.no_stadat_table_to_show"), env.opts.autoescape);
output += "</li>";
;
}
output += "\r\n                \r\n                ";
output += "\r\n            </ul>\r\n            <div id=\"autoload-progress\"><img src=\"assets/loading.gif\" alt=\"\"><br>";
output += runtime.suppressValue(env.getFilter("trans").call(context, "catalog.loading_data"), env.opts.autoescape);
output += "</div>\r\n        </div>\r\n    ";
});
}
else {
output += "\r\n        <div id=\"catalog-title\" class=\"title-block\">\r\n            <h1>";
output += runtime.suppressValue(env.getFilter("trans").call(context, "error.title"), env.opts.autoescape);
output += "</h1>\r\n        </div>\r\n        <div id=\"catalog-list\" style=\"margin-top:10px;padding-top:10px;\">";
output += runtime.suppressValue(env.getFilter("trans").call(context, "error.no_such_item"), env.opts.autoescape);
output += "</div>\r\n    ";
;
}
output += "\r\n</div>\r\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_sidebar(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var frame = frame.push(true);
output += "\r\n    ";
var tasks = [];
tasks.push(
function(callback) {
env.getTemplate("widgets/calendar.html", false, "stadat/catalog.html", false, function(t_18,t_17) {
if(t_18) { cb(t_18); return; }
callback(null,t_17);});
});
tasks.push(
function(template, callback){
template.render(context.getVariables(), frame, function(t_20,t_19) {
if(t_20) { cb(t_20); return; }
callback(null,t_19);});
});
tasks.push(
function(result, callback){
output += result;
callback(null);
});
env.waterfall(tasks, function(){
output += "\r\n\r\n    <div id=\"view-switcher\">\r\n        <p class=\"to-calendar-view\"><a href=\"";
output += runtime.suppressValue((lineno = 72, colno = 49, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["stadat_calendar"])), env.opts.autoescape);
output += "\"><img src=\"assets/view_calendar.png\" alt=\"\"> ";
output += runtime.suppressValue(env.getFilter("trans").call(context, "catalog.switch_to_calendar"), env.opts.autoescape);
output += "</a></p>\r\n    </div>\r\n\r\n    <div id=\"catalog-topics\">\r\n        <div class=\"box-title\"><h2>";
output += runtime.suppressValue(env.getFilter("trans").call(context, "catalog.topics_title"), env.opts.autoescape);
output += "</h2></div>\r\n        <div class=\"box\">\r\n            <div class=\"box-wrap\">\r\n                <ul id=\"topics-list\">\r\n                    <li";
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "get")),"topic")) {
output += " class=\"selected\"";
;
}
output += ">\r\n                        <a href=\"";
output += runtime.suppressValue((lineno = 81, colno = 37, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["stadat_index"])), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(env.getFilter("trans").call(context, "catalog.all_topics"), env.opts.autoescape);
output += "</a>\r\n                        ";
output += "\r\n                    </li>\r\n                    ";
frame = frame.push();
var t_23 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "topics")),"abc");
if(t_23) {t_23 = runtime.fromIterator(t_23);
var t_22 = t_23.length;
for(var t_21=0; t_21 < t_23.length; t_21++) {
var t_24 = t_23[t_21];
frame.set("topic", t_24);
frame.set("loop.index", t_21 + 1);
frame.set("loop.index0", t_21);
frame.set("loop.revindex", t_22 - t_21);
frame.set("loop.revindex0", t_22 - t_21 - 1);
frame.set("loop.first", t_21 === 0);
frame.set("loop.last", t_21 === t_22 - 1);
frame.set("loop.length", t_22);
output += "\r\n                        <li";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "get")),"topic") == runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "topics")),"urlMap")),t_24)) {
output += " class=\"selected\"";
;
}
output += ">\r\n                            <a href=\"";
output += runtime.suppressValue((lineno = 86, colno = 41, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["stadat_topic",env.getFilter("defaults").call(context, {"topic": runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "topics")),"urlMap")),t_24)},runtime.contextOrFrameLookup(context, frame, "filters"))])), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(t_24, env.opts.autoescape);
output += "</a>\r\n                            ";
output += "\r\n                        </li>\r\n                    ";
;
}
}
frame = frame.pop();
output += "\r\n                </ul>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    \r\n    ";
var tasks = [];
tasks.push(
function(callback) {
env.getTemplate("stadat/sidebar_download.html", false, "stadat/catalog.html", false, function(t_26,t_25) {
if(t_26) { cb(t_26); return; }
callback(null,t_25);});
});
tasks.push(
function(template, callback){
template.render(context.getVariables(), frame, function(t_28,t_27) {
if(t_28) { cb(t_28); return; }
callback(null,t_27);});
});
tasks.push(
function(result, callback){
output += result;
callback(null);
});
env.waterfall(tasks, function(){
output += "\r\n    ";
var tasks = [];
tasks.push(
function(callback) {
env.getTemplate("widgets/update_notice.html", false, "stadat/catalog.html", false, function(t_30,t_29) {
if(t_30) { cb(t_30); return; }
callback(null,t_29);});
});
tasks.push(
function(template, callback){
template.render(context.getVariables(), frame, function(t_32,t_31) {
if(t_32) { cb(t_32); return; }
callback(null,t_31);});
});
tasks.push(
function(result, callback){
output += result;
callback(null);
});
env.waterfall(tasks, function(){
output += "\r\n";
cb(null, output);
})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
b_content: b_content,
b_sidebar: b_sidebar,
root: root
};

})();
})();
